import styled from 'styled-components';
import { Table } from 'components/molecules/table';
import { HelperText, Text01 } from 'components/styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const PrimaryText = styled.div`
  ${Text01};
`;
export const SecondaryText = styled.div`
  ${HelperText};
`;

export const StyledTable = styled(Table)`
  td.phase {
    display: flex;
  }

  .ant-table-tbody > tr > td.start-date {
    padding-left: var(--spacing-05);
  }
`;
